import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useCareLogger } from '../../../composables/logger/useCareLogger'

export function useGetJwtTokenOption() {
  const { logIntercomError } = useCareLogger()

  const $httpFetch = useHttpFetch()

  function getJwtTokenOption() {
    return $httpFetch(
      '/api/care-platform/v1/intercom-customer-authentication-token',
      {
        method: 'GET',
        query: {
          platform: 'web',
        },
        onResponseError: ({ response }) => {
          if (response) {
            logIntercomError({
              errorTitle: '[INTERCOM] error when initiating',
              errorDetail: {
                type: 'fetch',
                context:
                  "Failed to fetch the intercom authenticate customer and we can't initiate intercom",
                // eslint-disable-next-line no-underscore-dangle
                error: response._data,
              },
            })
          }
        },
      },
    )
  }

  return {
    getJwtTokenOption,
  }
}
